// src/pages/RegistrationPage.jsx (Public Portal)
import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
// Make sure this imports the AuthContext for the PUBLIC PORTAL
import { useAuth } from '../context/AuthContext';

// Define Gender options (match backend model)
const GENDER_OPTIONS = ['Male', 'Female', 'Other', 'Prefer not to say'];

// --- Basic List of Countries ---
// Consider using a library or more comprehensive list for production
const COUNTRY_LIST = [
  "Afghanistan", "Albania", "Algeria", "Andorra", "Angola", "Antigua and Barbuda", "Argentina", "Armenia", "Australia", "Austria", "Azerbaijan",
  "Bahamas", "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bhutan", "Bolivia", "Bosnia and Herzegovina", "Botswana", "Brazil", "Brunei", "Bulgaria", "Burkina Faso", "Burundi",
  "Cabo Verde", "Cambodia", "Cameroon", "Canada", "Central African Republic", "Chad", "Chile", "China", "Colombia", "Comoros", "Congo, Democratic Republic of the", "Congo, Republic of the", "Costa Rica", "Cote d'Ivoire", "Croatia", "Cuba", "Cyprus", "Czech Republic",
  "Denmark", "Djibouti", "Dominica", "Dominican Republic",
  "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia", "Eswatini", "Ethiopia",
  "Fiji", "Finland", "France",
  "Gabon", "Gambia", "Georgia", "Germany", "Ghana", "Greece", "Grenada", "Guatemala", "Guinea", "Guinea-Bissau", "Guyana",
  "Haiti", "Honduras", "Hungary",
  "Iceland", "India", "Indonesia", "Iran", "Iraq", "Ireland", "Israel", "Italy",
  "Jamaica", "Japan", "Jordan",
  "Kazakhstan", "Kenya", "Kiribati", "Korea, North", "Korea, South", "Kosovo", "Kuwait", "Kyrgyzstan",
  "Laos", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libya", "Liechtenstein", "Lithuania", "Luxembourg",
  "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Marshall Islands", "Mauritania", "Mauritius", "Mexico", "Micronesia", "Moldova", "Monaco", "Mongolia", "Montenegro", "Morocco", "Mozambique", "Myanmar",
  "Namibia", "Nauru", "Nepal", "Netherlands", "New Zealand", "Nicaragua", "Niger", "Nigeria", "North Macedonia", "Norway",
  "Oman",
  "Pakistan", "Palau", "Palestine State", "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines", "Poland", "Portugal",
  "Qatar",
  "Romania", "Russia", "Rwanda",
  "Saint Kitts and Nevis", "Saint Lucia", "Saint Vincent and the Grenadines", "Samoa", "San Marino", "Sao Tome and Principe", "Saudi Arabia", "Senegal", "Serbia", "Seychelles", "Sierra Leone", "Singapore", "Slovakia", "Slovenia", "Solomon Islands", "Somalia", "South Africa", "South Sudan", "Spain", "Sri Lanka", "Sudan", "Suriname", "Sweden", "Switzerland", "Syria",
  "Taiwan", "Tajikistan", "Tanzania", "Thailand", "Timor-Leste", "Togo", "Tonga", "Trinidad and Tobago", "Tunisia", "Turkey", "Turkmenistan", "Tuvalu",
  "Uganda", "Ukraine", "United Arab Emirates", "United Kingdom", "United States of America", "Uruguay", "Uzbekistan",
  "Vanuatu", "Vatican City", "Venezuela", "Vietnam",
  "Yemen",
  "Zambia", "Zimbabwe"
].sort(); // Sort alphabetically
// -----------------------------


function RegistrationPage() {
    // --- State for Form Fields ---
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    // Removed profilePhoto state
    const [nationalId, setNationalId] = useState('');
    const [passportNumber, setPassportNumber] = useState('');
    // --- Default country state to Zambia ---
    const [countryOfBirth, setCountryOfBirth] = useState('Zambia');
    const [countryOfResidence, setCountryOfResidence] = useState('Zambia');
    // -------------------------------------
    const [residentialAddress, setResidentialAddress] = useState('');
    const [gender, setGender] = useState('');
    const [dateOfBirth, setDateOfBirth] = useState('');
    // --- End State ---

    const [errors, setErrors] = useState({});
    const [apiError, setApiError] = useState(null);
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const { register } = useAuth();
    const navigate = useNavigate();

    // --- Updated Client-Side Validation ---
    const validateForm = () => {
        const newErrors = {};
        if (!name.trim()) newErrors.name = 'Full Name is required';
        if (!email.trim()) { /* ... email validation ... */ }
        if (!password) { /* ... password validation ... */ }
        if (!nationalId.trim()) newErrors.nationalId = 'National ID is required';
        if (!countryOfBirth) newErrors.countryOfBirth = 'Country of Birth is required'; // Check for empty string
        if (!countryOfResidence) newErrors.countryOfResidence = 'Country of Residence is required';
        if (!residentialAddress.trim()) newErrors.residentialAddress = 'Residential Address is required';
        if (!gender) newErrors.gender = 'Gender is required';
        if (!dateOfBirth) newErrors.dateOfBirth = 'Date of Birth is required';
        // Removed profilePhoto validation

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    // --- End Validation ---

    // --- Updated Submit Handler ---
    const handleSubmit = async (event) => {
        event.preventDefault();
        setApiError(null); setSuccess(false);

        if (!validateForm()) { return; }

        setLoading(true);
        // --- Prepare data object without profilePhoto ---
        const userData = {
            name: name.trim(),
            email: email.trim(),
            password: password,
            // profilePhoto: null, // Removed
            nationalId: nationalId.trim(),
            passportNumber: passportNumber.trim() || null,
            countryOfBirth: countryOfBirth, // Send selected value
            countryOfResidence: countryOfResidence, // Send selected value
            residentialAddress: residentialAddress.trim(),
            gender: gender,
            dateOfBirth: dateOfBirth
        };
        // -----------------------------------------

        try {
            await register(userData);
            setSuccess(true);
            setTimeout(() => { navigate('/login'); }, 2000);
        } catch (err) {
            setApiError(err.response?.data?.message || 'Registration failed.');
            setLoading(false);
        }
    };
    // --- End Submit Handler ---

    return (
        <div className="registration-container">
            <img src="/img/logo.svg" alt="Logo" className="registration-logo" width="100" />
            <h2>Register Account</h2>

            {success ? (
                <p style={{ color: 'green', textAlign: 'center' }}>Registration successful! Redirecting to login...</p>
            ) : (
                <form onSubmit={handleSubmit} noValidate>
                    {apiError && <p className="error-message api-error">{apiError}</p>}

                    {/* --- Use two-column grid for fields --- */}
                    <div className="registration-grid">

                        {/* Column 1 */}
                        <div className="registration-column">
                            <div className="form-group">
                                <label htmlFor="name">Full Name:*</label>
                                <input type="text" id="name" value={name} onChange={(e) => setName(e.target.value)} aria-invalid={!!errors.name} aria-describedby="nameError"/>
                                {errors.name && <p id="nameError" className="error-message">{errors.name}</p>}
                            </div>
                             <div className="form-group">
                                <label htmlFor="email">Email:*</label>
                                <input type="email" id="email" value={email} onChange={(e) => setEmail(e.target.value)} aria-invalid={!!errors.email} aria-describedby="emailError"/>
                                {errors.email && <p id="emailError" className="error-message">{errors.email}</p>}
                            </div>
                             <div className="form-group">
                                <label htmlFor="password">Password:*</label>
                                <input type="password" id="password" value={password} onChange={(e) => setPassword(e.target.value)} aria-invalid={!!errors.password} aria-describedby="passwordError"/>
                                {errors.password && <p id="passwordError" className="error-message">{errors.password}</p>}
                            </div>
                             <div className="form-group">
                                <label htmlFor="nationalId">National ID:*</label>
                                <input type="text" id="nationalId" value={nationalId} onChange={(e) => setNationalId(e.target.value)} aria-invalid={!!errors.nationalId} aria-describedby="nationalIdError"/>
                                {errors.nationalId && <p id="nationalIdError" className="error-message">{errors.nationalId}</p>}
                            </div>
                             <div className="form-group">
                                <label htmlFor="gender">Gender:*</label>
                                <select id="gender" value={gender} onChange={(e) => setGender(e.target.value)} aria-invalid={!!errors.gender} aria-describedby="genderError">
                                    <option value="">-- Select Gender --</option>
                                    {GENDER_OPTIONS.map(g => <option key={g} value={g}>{g}</option>)}
                                </select>
                                {errors.gender && <p id="genderError" className="error-message">{errors.gender}</p>}
                            </div>
                        </div> {/* End Column 1 */}

                        {/* Column 2 */}
                        <div className="registration-column">
                             <div className="form-group">
                                <label htmlFor="dateOfBirth">Date of Birth:*</label>
                                <input type="date" id="dateOfBirth" value={dateOfBirth} onChange={(e) => setDateOfBirth(e.target.value)} aria-invalid={!!errors.dateOfBirth} aria-describedby="dobError"/>
                                {errors.dateOfBirth && <p id="dobError" className="error-message">{errors.dateOfBirth}</p>}
                            </div>
                             {/* --- Country of Birth Dropdown --- */}
                             <div className="form-group">
                                <label htmlFor="countryOfBirth">Country of Birth:*</label>
                                <select id="countryOfBirth" value={countryOfBirth} onChange={(e) => setCountryOfBirth(e.target.value)} aria-invalid={!!errors.countryOfBirth} aria-describedby="cobError">
                                    {/* <option value="">-- Select Country --</option> */} {/* Default is Zambia */}
                                    {COUNTRY_LIST.map(country => <option key={country} value={country}>{country}</option>)}
                                </select>
                                {errors.countryOfBirth && <p id="cobError" className="error-message">{errors.countryOfBirth}</p>}
                            </div>
                             {/* --- Country of Residence Dropdown --- */}
                             <div className="form-group">
                                <label htmlFor="countryOfResidence">Country of Residence:*</label>
                                <select id="countryOfResidence" value={countryOfResidence} onChange={(e) => setCountryOfResidence(e.target.value)} aria-invalid={!!errors.countryOfResidence} aria-describedby="corError">
                                     {/* <option value="">-- Select Country --</option> */} {/* Default is Zambia */}
                                     {COUNTRY_LIST.map(country => <option key={country} value={country}>{country}</option>)}
                                </select>
                                {errors.countryOfResidence && <p id="corError" className="error-message">{errors.countryOfResidence}</p>}
                            </div>
                             {/* --- Residential Address (Spans full width below columns) --- */}
                             <div className="form-group full-width-group">
                                <label htmlFor="residentialAddress">Residential Address:*</label>
                                <textarea id="residentialAddress"  value={residentialAddress} onChange={(e) => setResidentialAddress(e.target.value)} rows="6" aria-invalid={!!errors.residentialAddress} aria-describedby="addressError"></textarea>
                                {errors.residentialAddress && <p id="addressError" className="error-message">{errors.residentialAddress}</p>}
                            </div>
                            {/* --- Profile Photo Input Removed --- */}

                        </div> {/* End Column 2 */}

                    </div> {/* End Grid */}

                    <button type="submit" disabled={loading} className="submit-button">
                        {loading ? 'Registering...' : 'Register'}
                    </button>
                </form>
            )}

            <p style={{ textAlign: 'center', marginTop: '20px' }}>
                Already have an account? <Link to="/login">Login here</Link>
            </p>
        </div>
    );
}

export default RegistrationPage;
